import { render, staticRenderFns } from "./BuyerInfoInput.vue?vue&type=template&id=b88a8af0&"
import script from "./BuyerInfoInput.vue?vue&type=script&lang=js&"
export * from "./BuyerInfoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports